import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Text } from '@atlaskit/primitives/compiled/text';
import Spinner from '@atlaskit/spinner/spinner';
import { DropdownTrigger } from '@atlassian/entry-points/dropdown-trigger';

import { loadingDropdownEntryPoint } from '../fixtures/constellation/loading-dropdown-entry-point';
import { RelayWrapper } from '../utils/wrapper';

function CustomLoading(): React.JSX.Element {
	return (
		<Box padding="space.200">
			<Inline space="space.100" alignBlock="center">
				<Spinner size="small" label="" />
				<Text>Preparing page actions</Text>
			</Inline>
		</Box>
	);
}

export default function DropdownTriggerCustomLoading(): React.JSX.Element {
	return (
		<RelayWrapper>
			<DropdownTrigger
				entryPoint={loadingDropdownEntryPoint}
				trigger="Show custom loading"
				menuLabel="Page actions"
				fallback={<CustomLoading />}
				shouldRenderToParent
			/>
		</RelayWrapper>
	);
}
